module.exports = __webpack_public_path__ + "img/placeholder.870f1b89.png";